import {
  Box,
  Flex,
  FormLabel,
  Heading,
  Input,
  Stack,
  Textarea,
} from "@chakra-ui/react";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import MainInput from "../../../../components/Form/input";
import MainModel from "../../../../components/Models/main-model";
import { getAllChaptersRequest } from "../../../../modules/admin-modules/chapters/Actions";
import { getAllGroupsRequest } from "../../../../modules/admin-modules/groups/Actions";
import { closeCreateVideos } from "../../../../modules/admin-modules/models/Actions";
import {
  createVideoRequest,
  editVideoRequest,
  getPaymentSubjectRequest,
} from "../../../../modules/admin-modules/videos/Actions";
const AddVideo = ({ isAdd, data, setSelectedData }) => {
  const openVideo = useSelector((state) => state.model.isOpen5);
  const isLoading = useSelector((state) => state.videos.isLoading);
  const chapters = useSelector((state) => state.chapters.chapters);
  const groups = useSelector((state) => state.groups.groups);
  const paymentSubjects = useSelector((state) => state.videos.paymentSubjects);

  const [totalPlayed, setTotalPlayed] = useState(false);

  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: data
      ? { ...data, title: data?.title }
      : { publish: 0, auto_controlled: 1 },
    shouldUnregister: true,
  });

  const groupsOptions = groups?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const chaptersOptions = chapters?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const paymentSubjectsOptions = paymentSubjects?.map((data) => {
    return { value: data.id, label: data.name };
  });

  useEffect(() => {
    if (openVideo) {
      if (chapters.length == 0) dispatch(getAllChaptersRequest());
      if (groups.length == 0) dispatch(getAllGroupsRequest());
      dispatch(getPaymentSubjectRequest());
    }
  }, [openVideo]);
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        {isAdd ? "اضافة فيديو " : "تعديل فيديو"}
      </Heading>
    </Box>
  );
  const onSubmit = async (values) => {
    const action = () => {
      dispatch(closeCreateVideos());
      reset();
      setTotalPlayed(false);
      setSelectedData(() => {});
    };
    let formdata = {};
    const totel = { ...data, ...values };
    for (let key in totel) {
      if (values[key] === "true") formdata[key] = true;
      else if (values[key] === "false") formdata[key] = false;
      else formdata[key] = values[key];
    }
    if (isAdd) {
      dispatch(createVideoRequest(formdata, action));
    } else {
      formdata["_method"] = "PUT";
      dispatch(
        editVideoRequest({
          id: data?.id,
          formData: formdata,
          action: action,
        })
      );
    }
  };

  const closeFunc = () => {
    dispatch(closeCreateVideos());
    setSelectedData(() => {});
  };
  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openVideo}
      buttonTitle={" حفظ التغيرات"}
      buttonFunc={handleSubmit(onSubmit)}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex
          dir="rtl"
          w="100%"
          flexWrap="wrap"
          justifyContent="space-between"
          gap="5"
        >
          <Box w="45%">
            <MainInput
              label=" عنوان الفيديو"
              defaultValues={data?.title}
              error={errors?.title?.message}
              placeholder="  اكتب عنوان الفيديو"
              register={register}
              name="title"
            />
          </Box>
          <Box w="45%">
            <MainInput
              type="datetime-local"
              label=" تاريخ انتهاء الفيديو"
              defaultValues={data?.expiry_date ? dayjs(data?.expiry_date).format("YYYY-MM-DDTHH:mm") : ""}
              error={errors?.expiry_date?.message}
              placeholder="  ادخل تاريخ انتهاء الفيديو"
              register={register}
              name="expiry_date"
            />
          </Box>
          <Box w="45%">
            <MainInput
              label=" اضافة رابط للفيديو"
              defaultValues={data?.url}
              error={errors?.url?.message}
              placeholder="  اضافة رابط للفيديو"
              register={register}
              name="url"
            />
          </Box>
          <Box w="45%">
            <FormLabel> نبذة عن المحتوى : </FormLabel>
            <Textarea
              bg="#f5f5f5"
              defaultValue={data?.description}
              placeholder="اكتب نبذة مبسطة عن المحتوى"
              {...register("description", { required: false })}
              name="description"
            ></Textarea>
          </Box>
          <Box w="45%">
            <Box w="100%">
              <FormLabel>الفصول : </FormLabel>
              <Select
                options={chaptersOptions}
                defaultValue={{
                  label: data?.chapter?.name,
                  value: data?.chapter?.id,
                }}
                onChange={(data) => setValue("chapter_id", data.value)}
                styles={colourStyles}
                placeholder="الصف"
              />
            </Box>
          </Box>
          <Box w="45%">
            <Box w="100%">
              <FormLabel>حصة الدفع : </FormLabel>
              <Select
                options={paymentSubjectsOptions}
                defaultValue={{
                  label: data?.payment_subject?.name,
                  value: data?.payment_subject?.id,
                }}
                onChange={(data) => setValue("payment_subject_id", data.value)}
                styles={colourStyles}
                placeholder="payment subject"
              />
            </Box>
          </Box>
          <Box w="45%">
            <FormLabel> المجموعات : </FormLabel>

            <Select
              options={groupsOptions}
              isMulti
              onChange={(data) => {
                data?.map((val, index) => {
                  setValue(`student_group_ids[${index}]`, val?.value);
                });
              }}
              styles={colourStyles}
              placeholder="مجموعات"
              defaultValue={data?.student_groups?.map((val) => {
                return { label: val?.name, value: val?.id };
              })}
            />
          </Box>
          <Box w="25%">
            <FormLabel>نشر الفيديو : </FormLabel>
            <Stack
              direction="row"
              role="group"
              aria-labelledby="my-radio-group"
            >
              <label>
                <input
                  {...register("publish", { required: true })}
                  type="radio"
                  value="false"
                  defaultChecked={data?.publish ? "true" : "false"}
                />
                عدم نشر
              </label>
              <label>
                <input
                  {...register("publish", { required: true })}
                  type="radio"
                  value="true"
                  defaultChecked={data?.publish ? "true" : "false"}
                />
                نشر
              </label>
            </Stack>
          </Box>
          {/* type */}
          <Box w="25%">
            <FormLabel> نوع الفيديو : </FormLabel>
            <Stack
              direction="row"
              role="group"
              aria-labelledby="my-radio-group"
            >
              <label>
                <input
                  {...register("type", { required: true })}
                  type="radio"
                  value="1"
                  defaultChecked={data?.type == 1 ? true : false}
                />
                Agwad
              </label>
              <label>
                <input
                  {...register("type", { required: true })}
                  type="radio"
                  value="7"
                  defaultChecked={data?.type == 7 ? true : false}
                />
                Study with Agwad
              </label>
            </Stack>
          </Box>
          
          <Box w="25%">
            <FormLabel> هل يحتوي علي واجب؟ : </FormLabel>
            <Stack
              direction="row"
              role="group"
              aria-labelledby="my-radio-group"
            >
              <label>
                <input
                  {...register("related_to_homework", { required: true })}
                  type="radio"
                  value={true}
                  defaultChecked={data?.related_to_homework ? "true" : "false"}
                />
                نعم{" "}
              </label>
              <label>
                <input
                  {...register("related_to_homework", { required: true })}
                  type="radio"
                  value={false}
                  defaultChecked={data?.related_to_homework ? "true" : "false"}
                />
                لا
              </label>
            </Stack>
          </Box>
          <Box w="25%">
            <FormLabel> حالة الفيديو : </FormLabel>
            <Stack
              direction="row"
              role="group"
              aria-labelledby="my-radio-group"
            >
              <label>
                <input
                  {...register("suspended", { required: true })}
                  type="radio"
                  value={true}
                  defaultChecked={data?.suspended ? "true" : "false"}
                />
                ايقاف
              </label>
              <label>
                <input
                  {...register("suspended", { required: true })}
                  type="radio"
                  value={false}
                  defaultChecked={data?.suspended ? "true" : "false"}
                />
                تشغيل
              </label>
            </Stack>
          </Box>
          <Box w="45%">
            <FormLabel> مشاهدات الفيديو : </FormLabel>
            <Stack
              direction="row"
              role="group"
              aria-labelledby="my-radio-group"
            >
              <label>
                <input
                  {...register("auto_controlled", { required: true })}
                  type="radio"
                  value="0"
                  defaultChecked={data?.auto_controlled == 0 ? true : false}
                  onChange={() => setTotalPlayed(false)}
                />
                not limited
              </label>
              <label>
                <input
                  {...register("auto_controlled", { required: true })}
                  type="radio"
                  value="1"
                  defaultChecked={data?.auto_controlled == 1 ? true : false}
                  onChange={() => setTotalPlayed(false)}
                />
                limited views
              </label>
              <label>
                <input
                  {...register("auto_controlled", { required: true })}
                  type="radio"
                  onChange={() => setTotalPlayed(true)}
                />
                controlled views
              </label>
            </Stack>

            <br />
            {totalPlayed && (
              <Input
                {...register("auto_controlled", { required: true })}
                bg="#f5f5f5"
                defaultValue={data?.total_played}
                type="number"
                placeholder="full play count"
              />
            )}
          </Box>
        </Flex>
      </form>
    </MainModel>
  );
};

export default AddVideo;
